<template>
  <header class="tw-mb-8 tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between">
    <div>
      <h1 class="tw-text-2xl md:tw-text-3xl tw-font-semibold tw-text-slate-900">
        It's time to confirm your order!
      </h1>
      <p class="tw-mt-2 tw-text-sm tw-text-slate-600">
        Simply review your quote, confirm the specifications are correct, then complete payment using our secure checkout process.
      </p>
    </div>

    <div class="tw-mt-4 md:tw-mt-0 tw-flex tw-items-center tw-space-x-3">
      <a
        v-if="whatsappUrl"
        :href="whatsappUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="tw-inline-flex tw-items-center tw-rounded-md tw-bg-emerald-600 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-white tw-shadow-sm hover:tw-bg-emerald-700 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-emerald-500 focus:tw-ring-offset-2"
        aria-label="Open WhatsApp chat"
      >
        <svg
          class="tw-h-4 tw-w-4"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M21 11.5a8.38 8.38 0 0 1-.9 3.8A8.5 8.5 0 0 1 12.5 20a8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7A8.38 8.38 0 0 1 4 11.5 8.5 8.5 0 0 1 12.5 3 8.5 8.5 0 0 1 21 11.5Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="tw-ml-2">Got a question?</span>
      </a>

      <div class="tw-flex tw-items-center tw-space-x-2 tw-rounded-full tw-bg-white tw-shadow tw-px-3 tw-py-1">
        <span class="tw-inline-flex tw-h-2 tw-w-2 tw-rounded-full tw-bg-emerald-500" />
        <span class="tw-text-xs tw-font-medium tw-text-slate-700">Encrypted &amp; secure</span>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    whatsappUrl: {
      type: String,
      default: ''
    }
  }
}
</script>
